import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import { getAppConfig } from '@icp/settings';
import listeners from './features/listeners';
import agentSlice, { setSkillKB } from './features/agentSlice';

const reducer = {
  [agentSlice.name]: agentSlice.reducer,
};

export default function makeStore({ apiUrls, extra }) {
  const listenerMiddleware = createListenerMiddleware({ extra });

  listeners.forEach((listener) => listenerMiddleware.startListening(listener));

  const store = configureStore({
    reducer,
    // preloadedState: {},
    devTools:
      process.env.NODE_ENV !== 'production' || window.ICP_REDUX_DEBUG ? { name: `Agent` } : false,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: { apiUrls },
        },
      }).prepend(listenerMiddleware.middleware),
  });

  const appConfig = getAppConfig();
  if (appConfig?.agent?.initialSkill !== undefined) {
    store.dispatch(setSkillKB(appConfig?.agent?.initialSkill));
  }

  const clearListeners = () => {
    listenerMiddleware.clearListeners();
  };

  return [store, clearListeners];
}
